import { render, staticRenderFns } from "./SettingsLocationsForm.vue?vue&type=template&id=4e663df0"
import script from "./SettingsLocationsForm.vue?vue&type=script&lang=js"
export * from "./SettingsLocationsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports